export const common = {
  // Header
  "nav.home": "Accueil",
  "nav.vehicles": "Nos Véhicules",
  "nav.services": "Services",
  "nav.about": "À Propos",
  "nav.contact": "Contact",
  "header.call": "Appelez-nous 24h/7j",
  "header.book": "Réserver Maintenant",

  // Hero Section
  "hero.title": "LE STYLE, LA PUISSANCE, L'ATTITUDE - C'EST NPA",
  "hero.subtitle": "Location de Voitures de Luxe Premium à Douala",
  "hero.description": "Découvrez le summum du transport de luxe avec notre flotte exclusive de véhicules haut de gamme. Des réunions d'affaires aux occasions spéciales, nous fournissons le véhicule parfait pour chaque moment.",
  "hero.cta": "Découvrir Notre Flotte",
  "hero.whatsapp": "Réservation WhatsApp",

  // Vehicles Page
  "vehicles.title": "Nos Véhicules",
  "vehicles.subtitle": "Découvrez notre collection complète de véhicules",
  "vehicles.all": "Tous",
  "vehicles.suv": "SUV",
  "vehicles.4x4": "4x4",
  "vehicles.tourism": "Tourisme",
  "vehicles.sedan": "Berline",
  "vehicles.utility": "Utilitaires",
  "vehicles.book": "Réserver",
  "vehicles.seats": "places",
  "vehicles.transmission": "Automatique",
  "vehicles.fuel": "Essence",

  // Fleet Section
  "fleet.title": "Notre Flotte Premium",
  "fleet.subtitle": "Découvrez notre collection de véhicules de luxe",
  "fleet.year": "Année",
  "fleet.transmission": "Automatique",
  "fleet.fuel": "Essence",
  "fleet.seats": "places",
  "fleet.book": "Réserver",

  // Services Section
  "services.title": "Nos Services",
  "services.subtitle": "Services premium pour chaque occasion",
  "services.airport.title": "Transfert Aéroport",
  "services.airport.desc": "Transferts confortables et ponctuels vers et depuis l'Aéroport International de Douala",
  "services.business.title": "Voyage d'Affaires",
  "services.business.desc": "Transport professionnel pour vos réunions d'affaires et événements corporatifs",
  "services.events.title": "Événements Spéciaux",
  "services.events.desc": "Véhicules de luxe pour mariages, célébrations et occasions spéciales",
  "services.chauffeur.title": "Service Chauffeur",
  "services.chauffeur.desc": "Chauffeurs professionnels disponibles pour votre confort et sécurité",

  // Why Choose Us Section
  "why.title": "Pourquoi Choisir NPA?",
  "why.subtitle": "L'excellence dans chaque détail",
  "why.luxury.title": "Flotte de Luxe",
  "why.luxury.desc": "Véhicules premium de 2020-2024, méticuleusement entretenus",
  "why.service.title": "Service 24h/7j",
  "why.service.desc": "Disponible à tout moment, partout à Douala et environs",
  "why.professional.title": "Chauffeurs Professionnels",
  "why.professional.desc": "Chauffeurs expérimentés et courtois pour votre sécurité",
  "why.competitive.title": "Tarifs Compétitifs",
  "why.competitive.desc": "Meilleur rapport qualité-prix pour la location de voitures de luxe au Cameroun",

  // Location Section
  "location.title": "Notre Localisation",
  "location.subtitle": "Visitez-nous à Douala",
  "location.address": "Rhône-Poulenc, Douala, Cameroun - En face de l'Eglise évangélique",
  "location.hours": "Ouvert 24h/7j",
  "location.directions": "Obtenir l'Itinéraire",

  // Booking Section
  "booking.title": "Réservez Votre Véhicule de Luxe",
  "booking.subtitle": "Contactez-nous pour un service personnalisé et des tarifs compétitifs",
  "booking.name": "Nom Complet",
  "booking.phone": "Numéro de Téléphone",
  "booking.email": "Adresse Email",
  "booking.vehicle": "Véhicule Préféré",
  "booking.date": "Date de Location",
  "booking.duration": "Durée de Location",
  "booking.message": "Exigences Supplémentaires",
  "booking.submit": "Envoyer Demande WhatsApp",
  "booking.select": "Sélectionner un véhicule",
  "booking.days": "Nombre de jours",

  // Footer
  "footer.tagline": "LE STYLE, LA PUISSANCE, L'ATTITUDE - C'EST NPA",
  "footer.description": "Votre partenaire de confiance pour la location de voitures de luxe à Douala, Cameroun. Découvrez l'excellence avec notre flotte premium.",
  "footer.contact": "Contact",
  "footer.follow": "Suivez-Nous",
  "footer.rights": "Tous droits réservés.",
  "footer.powered": "WOW (WhatsApp Order Website) powered by Wazi Consulting"
};

export default common;